import { calcOf } from "../../wizard/shared";

/**
 * Template mapping payload — never duplicate formulas on the template row.
 */
export function buildTemplateComponentLinkPayload(templateId, comp, sequence) {
  const calc = calcOf(comp);
  const base = {
    template_id: templateId,
    component_id: comp.component_id,
    sequence,
  };
  const code = String(comp.code || comp.system_code || comp.name || "COMPONENT").trim();

  if (calc === "system") {
    const ref = String(comp.system_code || code).trim();
    return {
      ...base,
      calculation_source: "statutory_engine",
      reference: ref,
    };
  }
  if (calc === "formula") {
    return {
      ...base,
      calculation_source: "component_formula",
      reference: code,
    };
  }
  if (calc === "fixed") {
    return {
      ...base,
      calculation_source: "component_reference",
      reference: code,
    };
  }
  return {
    ...base,
    calculation_source: "component_reference",
    reference: code,
  };
}
